module.exports = __webpack_public_path__ + "static/img/experimental_small.fdd473b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/experimental_small.jpg
// module id = XcgB
// module chunks = 0